var _excluded = ["children", "disabled", "size"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import styled from 'styled-components';
var variantStyles = {
  small: {
    font: 'var(--body-text-x-small)',
    padding: 'var(--spacing-1)'
  },
  medium: {
    font: 'var(--body-text-small)',
    padding: 'var(--spacing-1) var(--spacing-2)'
  },
  large: {
    font: 'var(--body-text-medium)',
    padding: 'var(--spacing-2) var(--spacing-3)'
  }
};
var StyledLi = styled.li.withConfig({
  componentId: "CL__sc-1l33jdw-0"
})(["list-style:none;button{border:none;margin:0;}a:hover{text-decoration:none;}a,button{background-color:rgba(0,0,0,0);border-radius:var(--border-radius-small);color:inherit;cursor:pointer;display:block;font:", ";outline:none;padding:", ";overflow:hidden;text-align:left;text-overflow:ellipsis;transition-property:background-color,color;transition:var(--hover-transition) var(--transition-easing);white-space:nowrap;width:100%;&:hover,ul:not(:hover) > &:focus{background-color:var(--dropdown-bkg-hover-color);color:var(--link-color);}&:active,&:active:hover{background-color:var(--dropdown-bkg-active-color);}}&[data-disabled='true'] a,&[data-disabled='true'] button,button:is(:disabled,[aria-disabled='true']){background-color:var(--surface-bkg-color);cursor:default;opacity:0.5;pointer-events:none;&:hover,&:focus{background-color:var(--surface-bkg-color);color:inherit;}}"], _ref => {
  var {
    $size
  } = _ref;
  return variantStyles[$size].font;
}, _ref2 => {
  var {
    $size
  } = _ref2;
  return variantStyles[$size].padding;
});
var DropdownMenuItem = _ref3 => {
  var {
      children,
      disabled = false,
      size = 'medium'
    } = _ref3,
    props = _objectWithoutProperties(_ref3, _excluded);
  return /*#__PURE__*/React.createElement(StyledLi, _extends({
    "data-disabled": disabled,
    $disabled: disabled,
    $size: size
  }, props), children);
};
export default DropdownMenuItem;